export default "__VITE_ASSET__Q6vl_iJs__"